"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBWebSockets = void 0;
const web_ui_features_1 = require("@gruposantander/web-ui-features");
class MBWebSockets extends web_ui_features_1.WebSocketsV2 {
    constructor() {
        super(...arguments);
        this.connectAndRefreshToken = async (refreshToken) => {
            const connection = await super.connect();
            await refreshToken();
            return connection;
        };
    }
}
exports.MBWebSockets = MBWebSockets;
//# sourceMappingURL=websockets.js.map